import { PixelIcon } from "./PixelArt";
import { GOAL_BAR_CELLS, HOUSE_WEEK_WORDS, goalCells, goalLine, themeByKey, weekSignLabel, type HouseWeekSummary } from "../../shared/house-week.ts";

/**
 * The house's week on the notice board (docs/house-week.md). Owner, 2026-10-29, picking "Themed weeks
 * ... the board gets a banner" and "House goal of the week. One shared target on the notice board
 * ("30 chores this week") with a progress bar".
 *
 * - The theme (themeWeekUI): a cloth banner pinned across the cork, red with a square notch cut in each
 *   end, the week's name in gold Silkscreen and its line in cream under it.
 * - The goal (houseGoalUI): a paper sign like the slop tally's, pinned at both top corners: "House goal",
 *   the progress bar (ink-ruled, GOAL_BAR_CELLS gold cells, full only once reached), "12 of 30 chores",
 *   and once reached "Reached! 20 wood each."
 *
 * Under the lead and the slop tally, above the slips' columns, never one of them. Nothing to press.
 */
export function WeekSign({ week, theme: showTheme, goal: showGoal }: { week: HouseWeekSummary; theme: boolean; goal: boolean }) {
  const theme = showTheme ? themeByKey(week.theme) : null;
  const goal = showGoal ? week.goal : null;
  if (!theme && !goal) return null;
  const filled = goal ? goalCells(goal.done, goal.target) : 0;
  return (
    <div class="week-sign" role="group" aria-label={weekSignLabel(theme, goal)}>
      {theme && (
        <div class="week-banner" aria-hidden="true">
          <span class="week-banner-name">{theme.name}</span>
          <span class="week-banner-line">{theme.line}</span>
        </div>
      )}
      {goal && (
        <div class="week-goal">
          <PixelIcon name="pinned" className="slop-pin left" />
          <PixelIcon name="pinned" className="slop-pin right" />
          <div class={`week-goal-paper${goal.reached_at ? " reached" : ""}`} aria-hidden="true">
            <span class="slop-head">{HOUSE_WEEK_WORDS.goalHead}</span>
            <span class="week-bar">
              {Array.from({ length: GOAL_BAR_CELLS }, (_, i) => (
                <i key={i} class={i < filled ? "on" : ""} />
              ))}
            </span>
            <span class="week-goal-line">{goalLine(goal)}</span>
            {goal.reached_at && <span class="week-goal-reached">{HOUSE_WEEK_WORDS.reached}</span>}
          </div>
        </div>
      )}
    </div>
  );
}
